import { initFancyBox } from "@common/index";
import { countUp, debounce } from "../utils/utils";

const _ourServices = () => {
  const pageMarker = $("._ourServices_");
  if (!pageMarker.length) return;
  $(function () {
    // if (window.innerWidth === 1350 || window.innerWidth === 412) {
    //   $(document).one("mousemove", () => {
    //     initFunction();
    //   });
    //   $(document).one("scroll", () => {
    //     initFunction();
    //   });
    // } else {
    //   initFunction();
    // }
    initFunction();
  });

  let initFunction = () => {

    initFunction = () => { };
    initFancyBox();
    initEvent();
    countUp(".counter");
  };

  function initEvent() {
    copyWorkflowsItem()
    if(screen.width < 621){
      const w = $('.gads ._content_')
      $(w).css('--roundWidth', w.width() as number)
      $(w).css('--roundWidth2', w.width() as number + 'px')
    }
  }
  $('._ourServices_ .sem .right .list .item').on('mouseenter',debounce(function(this: any){
    console.log('mouseenter');
    
    $(this).find('article').trigger('click');
    $(this).addClass('active').siblings().removeClass('active');
  }))

  function copyWorkflowsItem() {
    const item = $('.closed-loop .closed-list .list:nth-child(1) li:nth-child(2n)');
    $('.list-copy').append(item.clone());
  }

};

export default _ourServices;
